import { ResultError } from '../result/result-error';
import { IPickPreCheckError, PreCheckErrorMixin } from './pre-check-error';

export class PickBalanceOptionPreCheckError extends PreCheckErrorMixin(ResultError) implements IPickPreCheckError {
    constructor(pickId: string) {
        super(pickId);
    }
}
